<app-driveb-master-wrapper>
  <div class="dialog-header first">
    <h3 translate>dialog-before-manually-warning-user-add-part-budget.title</h3>
    <button
      class="close-button relative"
      mat-icon-button
      tabindex="-1"
      cdkFocusInitial
      (click)="callCloseDialog()"
      id="message-before-manually-add-part-modal-header-button-close"
    >
      <i class="bosch-ic bosch-ic-clickable bosch-ic-close"></i>
    </button>
  </div>

  <div class="dialog-actions">
    <button
      class="sample-button sample-button--primary"
      (click)="callUseExistingPart()"
      style="height: 49px"
      id="message-before-manually-add-part-modal-form-button-use-existing-part"
    >
      {{ "input-cancel" | translate }}
    </button>
    <button
      mat-button
      (click)="callCreatePart()"
      style="height: 49px"
      id="message-before-manually-add-part-modal-form-button-create-part"
    >
      {{ "input-continue-anyway" | translate }}
    </button>
  </div>
</app-driveb-master-wrapper>
